/*
 * @Descripttion:
 * @version: 2.0.0.0
 * @Author: ysanyu
 * @Date: 2020-08-22 16:12:39
 * @LastEditors: ysanyu
 * @LastEditTime: 2020-10-10 23:12:45
 */
import router from './router'
import store from './store' // vuex
import { getCookie } from './utils/cookie' // 获取cookie

router.beforeEach(async(to, from, next) => {
  const cityName = getCookie('cityName')
  const tradeId = getCookie('tradeId')
  const publishId = getCookie('publishId')
  const config = getCookie('config')
  const turnover = getCookie('turnover')
  const token = getCookie('asses_token')
  const personList = getCookie('personList') !== 'undefined' ? JSON.parse(getCookie('personList')) : ''
  await store.dispatch('setToken', token || '')
  await store.dispatch('setCity', cityName || '')
  await store.dispatch('setTradeId', tradeId || '')
  await store.dispatch('setPublishId', publishId || '')
  await store.dispatch('setOnFreshConfig', config || '')
  await store.dispatch('setTurnover', turnover || 0)
  await store.dispatch('setPersonList', personList || [])
  document.title = to.meta.title
  next()
})
